import moment from 'moment';

export const transformDateForEditMode = (time) => {
  if (!time) {
    return '';
  }

  const timeString = moment(time).format('ddd M/D h:mmA');

  return timeString;
};

// Keep the time string of customized update to be consistent with FB
// Return time string format: 2021-11-15T17:47:56-08:00
export const getISOTimeStringWithTimeZone = (time) => {
  if (!time) {
    return '';
  }

  const timeString = moment(time).format('YYYY-MM-DDTHH:mm:ss');

  // Try to extract the timezone offset(+0800) from time string like
  // 'Fri Jan 21 2022 19:25:30 GMT+0800 (China Standard Time)'
  let offsetString = time.toString().match(/([-+][0-9]+)\s/)[1];

  offsetString = `${offsetString.slice(0, 3)}:${offsetString.slice(3)}`;

  return `${timeString}${offsetString}`;
};
